import { render, staticRenderFns } from "./root-ondemand-banner.vue?vue&type=template&id=5021098b"
import script from "./root-ondemand-banner.vue?vue&type=script&lang=js"
export * from "./root-ondemand-banner.vue?vue&type=script&lang=js"
import style0 from "./root-ondemand-banner.vue?vue&type=style&index=0&id=5021098b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports